function enhanceHeaderMenu(root = document) {
  root.querySelectorAll('header-menu').forEach((menu) => {
    if (menu.dataset.ambEnhanced) return;
    menu.dataset.ambEnhanced = 'true';

    menu.addEventListener('click', (event) => {
      const link = event.target.closest('.menu-list__link');
      if (!link) return;
      const item = link.closest('.menu-list__list-item');
      const submenu = item?.querySelector('[ref="submenu[]"]');
      if (!submenu) return;
      const expanded = item.getAttribute('aria-expanded') === 'true';
      if (!expanded) {
        event.preventDefault();
        item.setAttribute('aria-expanded', 'true');
      }
    });

    menu.addEventListener('keydown', (event) => {
      const link = event.target.closest('.menu-list__link');
      if (!link) return;
      const item = link.closest('.menu-list__list-item');
      const submenu = item?.querySelector('[ref="submenu[]"]');
      if (!submenu) return;
      if (event.key === 'Enter' || event.key === ' ') {
        if (item.getAttribute('aria-expanded') !== 'true') {
          event.preventDefault();
          item.setAttribute('aria-expanded', 'true');
        }
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        item.setAttribute('aria-expanded', 'false');
        link.focus();
      }
    });
  });
}

enhanceHeaderMenu();
new MutationObserver(() => enhanceHeaderMenu()).observe(document.documentElement, { childList: true, subtree: true });
